<!-- <ngb-carousel *ngIf="imagenes?.length>0" class="carousel slide carousel-fade">
  <ng-template ngbSlide *ngFor="let imagen of imagenes; let j=index">
    <div class="picsum-img-wrapper bg-tour-detail">
      <img [src]="imagen.imagen" style="height: 450px !important; width: -webkit-fill-available; object-fit: cover;" alt="Random first slide">
    </div>
    <div class="carousel-caption" style="margin-left: -10% !important; width: 100% !important;">
      <div class="container" style="margin-left: -4% !important;">
        <div class="row mb-3">
          <div class="col-md-1">
            <a href="javascript:history.back()" class="d-flex flex-row align-items-center text-decoration-none">
              <img src="assets/images/body/icons/volver.svg" class="pe-2" alt="">
              <h4 class="text-white mb-0" style="font-weight: 600 !important;"> Volver</h4>
            </a>
          </div>
        </div>
        <div class="row " style="text-align: initial ;">
          <div class="col-md-12">
            <h1 class="mb-1 text-white-tour">{{tourDetail?.nombre_paquete}}</h1>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ngb-carousel> -->

<ngb-carousel  class="carousel position-absolute slide w-100 carousel-fade" >
  <ng-template ngbSlide *ngFor="let imagen of imagenes; let j=index">
    <div class="carousel-inner bg-tour-detail tours-height">
      <div class=" carousel-item active" style="z-index: 0;">
        <img [src]="imagen.imagen" class="d-block " alt="..." style="height: 100% !important; width: -webkit-fill-available; object-fit: cover;">
      </div>
   </div>
  </ng-template>
</ngb-carousel>
 
  <section class="align-items-center d-flex tours-height" >
      <div class="position-relative tour-detail-title w-100">
          <div class="container">
              <div class="row mb-5">
                  <div class="col-lg-1">
                      <a href="javascript:history.back()" class="d-flex flex-row align-items-center text-decoration-none">
                          <img src="assets/images/body/icons/volver.svg" class="pe-2" alt="">
                          <h4 class="text-white mb-0"> Volver</h4>
                      </a>
                  </div>
              </div>
              <div class="row ">
                  <div class="col-lg-12">
                      <h1 class="mb-1 text-white">{{tourDetail?.nombre_paquete}}</h1>
                  </div>
              </div>
          </div>
      </div>
  </section>
<!--  -->

<section class="tour-detail-content" style="padding-top: 10rem; margin-top: -35px;">
  <div class="container">
    <div class="row">
      <div class="col-xl-1 col-xxl-2"></div>
      <div class="col-12 pb-2">
        <h4 class="title-bg mb-5">Información de Excursiones</h4>
      </div>
    </div>
   <!--  <div class="row" > -->
      <div class="space" style="padding-top: 8rem;" *ngIf="!excursions.length"  >      
      </div>
      <div *ngFor="let item of excursions; let i=index;">
      <div *ngIf="i%2===0" class="pb-5">
        <div class="bg-grey mx-0 px-lg-0 radius-30 row">
          <div class="col-lg-6 col-xl-6 col-xxl-6 position-relative px-0">
            <div class="bg-primary tours-pasajeros ps-0 overflow-hidden h-100 d-flex justify-content-center">
              <img src="{{item.imagen}}" class="d-block w-100" alt="...">
              <h3 class="px-lg-4 position-absolute text-center text-white top-50">{{item.titulo_excursion}}</h3>
            </div>
          </div>
          <div class="col-xxl-6 col-xl-6 col-lg-6 ">
            <div class="align-items-center bg-grey d-flex h-100 p-lg-4 p-3 radius-30">
              <p>{{item.descripcion_excursion}}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="i%2===1" class="pb-5">
        <div class="bg-grey mx-0 px-lg-0 radius-30 row">
          <div class="col-xxl-6 col-xl-6 col-lg-6 ">
            <div class="align-items-center bg-grey d-flex h-100 p-lg-4 p-3 radius-30 order-last order-lg-first">
              <p >{{item.descripcion_excursion}}
              </p>
            </div>
          </div>
          <div class="col-lg-6 col-xl-6 col-xxl-6 position-relative px-0 order-first order-lg-last">
            <div class="bg-primary tours-pasajeros ps-0 overflow-hidden h-100 d-flex justify-content-center">
              <img src="{{item.imagen}}" class="d-block w-100" alt="...">
              <h3 class="px-lg-4 position-absolute text-center text-white top-50 ">{{item.titulo_excursion}}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- </div> -->
  </div>
</section>
<section class="bg-home bg-tour-details z-index-top-">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center">

      </div>
    </div>
  </div>
</section>
